import { render, staticRenderFns } from "./ProductCertificateLogos.vue?vue&type=template&id=00794266&"
import script from "./ProductCertificateLogos.vue?vue&type=script&lang=js&"
export * from "./ProductCertificateLogos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports